
import { lang } from './th/lang';
import { dataSource } from './th/dataSource';
import { common } from './th/common';
import { login } from './th/login';
import { register } from './th/register';
import { pinLogin } from './th/pinLogin';
import { pos } from './th/pos';
import { receipt } from './th/receipt';
import { backOffice } from './th/backOffice';
import { modals } from './th/modals';
import { platform } from './th/platform';
import { errors } from './th/errors';

export const translations = {
  lang,
  dataSource,
  common,
  login,
  register,
  pinLogin,
  pos,
  receipt,
  backOffice,
  modals,
  platform,
  errors
};
